export default __webpack_public_path__ + "static/media/user.9dc92b0a.png";